// Serializuje pole ako ?a=1&a=2 namiesto ?a[]=1&a[]=2 (Flask štandard)
export const repeatParamsSerializer = (params: Record<string, any>): string =>
  Object.entries(params)
    .flatMap(([key, val]) =>
      Array.isArray(val)
        ? val.map((v) => `${key}=${encodeURIComponent(v)}`)
        : val != null ? [`${key}=${encodeURIComponent(val)}`] : []
    )
    .join('&')